import React from 'react'
import { Modal, Button, Space } from 'antd'
import { UploadOutlined, ScissorOutlined, RotateLeftOutlined, RotateRightOutlined } from '@ant-design/icons'

/**
 * Modal para editar y recortar imagen
 */
const ModalEdicionImagen = ({
  visible,
  onCancel,
  onLimpiarSeleccion,
  onAplicarRecorte,
  onContinuar,
  mostrarBotonContinuar,
  imagenParaEditar,
  rotacionAngulo,
  selectionStart,
  selectionEnd,
  cropImageRef,
  onMouseDownCrop,
  onMouseMoveCrop,
  onMouseUpCrop,
  onRotarIzquierda,
  onRotarDerecha,
}) => {
  const botonPrincipal = mostrarBotonContinuar ? (
    <Button
      key="continuar"
      type="primary"
      onClick={onContinuar}
    >
      Continuar (quitar fondo y colores)
    </Button>
  ) : (
    <Button
      key="guardar"
      type="primary"
      onClick={onAplicarRecorte}
      icon={<UploadOutlined />}
    >
      Guardar Foto
    </Button>
  )

  return (
    <Modal
      title="Editar y Recortar Foto del Material"
      open={visible}
      maskClosable={false}
      onCancel={onCancel}
      footer={[
        <Button key="cancelar" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="limpiar" onClick={onLimpiarSeleccion} disabled={!selectionStart || !selectionEnd}>
          Limpiar Selección
        </Button>,
        botonPrincipal
      ]}
      width={700}
    >
      {imagenParaEditar && (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
            <div style={{ fontSize: '14px', color: '#666', flex: 1 }}>
              <ScissorOutlined /> Arrastra para seleccionar el área que deseas recortar, o guarda la imagen completa
            </div>
            <Space>
              <Button 
                icon={<RotateLeftOutlined />} 
                onClick={onRotarIzquierda}
                title="Rotar 90° a la izquierda"
              >
                Rotar Izquierda
              </Button>
              <Button 
                icon={<RotateRightOutlined />} 
                onClick={onRotarDerecha}
                title="Rotar 90° a la derecha"
              >
                Rotar Derecha
              </Button>
            </Space>
          </div>
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
              border: '2px solid #d9d9d9',
              borderRadius: '4px',
              overflow: 'hidden',
              cursor: 'crosshair'
            }}
            onMouseDown={onMouseDownCrop}
            onMouseMove={onMouseMoveCrop}
            onMouseUp={onMouseUpCrop}
            onMouseLeave={onMouseUpCrop}
          >
            <img
              ref={cropImageRef}
              src={imagenParaEditar}
              alt="Imagen para editar"
              style={{
                maxWidth: '500px',
                maxHeight: '500px',
                height: 'auto',
                width: 'auto',
                display: 'block',
                userSelect: 'none',
                transform: `rotate(${rotacionAngulo}deg)`,
                transition: 'transform 0.3s ease'
              }}
              draggable={false}
            />
            {selectionStart && selectionEnd && (
              <div
                style={{
                  position: 'absolute',
                  left: Math.min(selectionStart.x, selectionEnd.x),
                  top: Math.min(selectionStart.y, selectionEnd.y),
                  width: Math.abs(selectionEnd.x - selectionStart.x),
                  height: Math.abs(selectionEnd.y - selectionStart.y),
                  border: '2px solid #1890ff',
                  backgroundColor: 'rgba(24, 144, 255, 0.1)',
                  pointerEvents: 'none',
                  boxSizing: 'border-box',
                  zIndex: 10
                }}
              />
            )}
          </div>
        </div>
      )}
    </Modal>
  )
}

export default ModalEdicionImagen
